export default __webpack_public_path__ + "static/media/matkaTimer.2ccf874a.svg";